<nav *ngIf="asset" class="breadcrumb">
	<a class="breadcrumb-item" [routerLink]="['../../../../']">My {{brand.fleetPlural}}</a>
	<a class="breadcrumb-item" [routerLink]="['../../']">{{fleet?.fleet_name}}</a>
	<span class="breadcrumb-item active super">{{asset?.asset_name}}<span *ngIf="asset && asset.asset_serial_number">
			({{asset.asset_serial_number}})</span></span>
</nav>
<div *ngIf="asset">
	<div *ngIf="asset && asset.is_fixed" class="row fixedassets">
		<!-- FIXED ASSETS ONLY -->
		<div class="col-lg-6">
			<div class="item-panel corner">
				<div class="heading">{{asset.alt_asset_term || brand.assetSingular}} OVERVIEW</div>
				<div class="content">
					<div class="row">
						<div class="col-md-6">
							<div *ngIf="asset.fleet_id === 0 || api.user?.support">
								<b>Organization:</b> {{asset.organization_name}}
							</div>
							<div *ngIf="asset.fleet_name">
								<b>{{brand.fleetSingular}}:</b> {{asset.fleet_name}}
							</div>
							<div *ngIf="!asset.fleet_name">
								<b>{{brand.fleetSingular}}:</b> {{fleet.fleet_name}}
							</div>
							<div>
								<b>{{asset.alt_asset_term || brand.assetSingular}}:</b> {{asset.asset_name}}
							</div>
							<div *ngIf="asset.asset_serial_number">
								<b>{{asset.alt_asset_term || brand.assetSingular}} Serial:</b> {{asset.asset_serial_number}}
							</div>
							<div>
								<b>Server ID:</b> {{asset.obcu_serial_number}}
							</div>
							<div>
								<b>{{asset.alt_asset_term || brand.assetSingular}} Type:</b> {{asset.asset_type_name | removeBaseline}}
							</div>
							<div *ngIf="asset.latest_assembly_version">
								<b>OBCU Config Version:</b> {{asset.latest_assembly_version}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- FIXED ASSETS ONLY -->
		<div class="col-lg-6">
			<div class="item-panel mobile">
				<div class="heading">{{brand.mechName}} Overview</div>
				<div class="content">
					<div class="row">
						<div class="col-md">
							<b>Highest HI:</b>
							<div class="big-number" [class.status-ok-fg]="(asset.mdmax | hilevel) === 1" [class.status-warning-fg]="(asset.mdmax | hilevel) === 3"
								[class.status-error-fg]="(asset.mdmax | hilevel) === 4">
								{{asset.mdmax | number : "1.2-2"}}
								<span class="hi-help" title="{{hiHelp}}">
									<i class="icon-help-circled"></i>
								</span>
							</div>
						</div>
						<div *ngIf="asset.rulmin" class="col-md mobile-pad-top">
							<div class="">
								<div class="rul-shortest">Shortest RUL:
									<span class="value">{{asset.rulmin | number : "1.2-2"}} hr</span>
								</div>
								<div *ngIf="asset.rulmin && worstrulcomponent" class="rul-component">Component:
									<span class="value">{{worstrulcomponent?.name}}</span>
								</div>
							</div>
						</div>
						<div *ngIf="(!asset.rulmin && !worstrulcomponent) && worsthicomponent" class="col-md mobile-pad-top">
							<div class="rul-component">Component:
								<span class="value">{{worsthicomponent?.name}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="asset && !asset.is_fixed" class="row">
		<!-- MOBILE ASSETS ONLY -->
		<div class="col-lg-4">
			<div class="item-panel corner">
				<div class="heading">{{asset.alt_asset_term || brand.assetSingular}} OVERVIEW</div>
				<div class="content">
					<img *ngIf="assetIcon" class="asset-image" [src]="'/brand/img/' + assetIcon + '.png'" />
					<div *ngIf="asset.fleet_id === 0 || api.user?.support">
						<b>Organization:</b> {{asset.organization_name}}
					</div>
					<div *ngIf="asset.fleet_name">
						<b>{{brand.fleetSingular}}:</b> {{asset.fleet_name}}
					</div>
					<div *ngIf="!asset.fleet_name">
						<b>{{brand.fleetSingular}}:</b> {{fleet.fleet_name}}
					</div>
					<div>
						<b>{{asset.alt_asset_term || brand.assetSingular}}:</b> {{asset.asset_name}}
					</div>
					<div *ngIf="asset.asset_serial_number">
						<b>{{asset.alt_asset_term || brand.assetSingular}} Serial:</b> {{asset.asset_serial_number}}
					</div>
					<div>
						<b>Server ID:</b> {{asset.obcu_serial_number}}
					</div>
					<div>
						<b>{{asset.alt_asset_term || brand.assetSingular}} Type:</b> {{asset.asset_type_name | removeBaseline}}
					</div>
					<div *ngIf="asset.latest_assembly_version">
						<b>OBCU Config Version:</b> {{asset.latest_assembly_version}}
					</div>
					<hr />
					<table>
						<tbody *ngIf="lastOperation">
							<tr *ngIf="lastOperation.flight_time > 0">
								<td class="column-spacer">Last {{brand.flightTime}}:</td>
								<td class="value">{{lastOperation.flight_time | runtime}}</td>
							</tr>
							<tr *ngIf="asset.flight_time !== null">
								<td class="column-spacer">Total {{brand.flightTime}}:</td>
								<td class="value">{{asset.flight_time | runtime}}</td>
							</tr>
							<tr>
								<td>&nbsp;</td>
								<td>&nbsp;</td>
							</tr>
						</tbody>
						<tbody *ngIf="components && components.engine && components.engine.length > 0">
							<tr *ngFor="let engine of components.engine">
								<td class="column-spacer">Engine {{engine.name}} HI:</td>
								<td class="value">
									{{(engine.state ? engine.state.filtered_hi : undefined) | number : "1.2-2" | ifempty : "N/A"}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<!-- MOBILE ASSETS ONLY -->
		<div class="col-lg-8 mt-3-md-down">
			<div class="item-panel mobile">
				<div class="heading">DIAGNOSTIC SUMMARY</div>
				<div class="content dark">
					<div class="row">
						<div class="col-6 col-md-4 detail-column">
							<div *ngIf="api.user.hide_rtb !== 1" class="detail-panel">
								<div class="section-title">Rotor Track + Balance</div>
								<div class="section-description">Highest Rotor Vibration Magnitude</div>
								<div class="big-number" [class.status-ok-fg]="(asset.rtbhealth | hilevel) === 1" [class.status-warning-fg]="(asset.rtbhealth | hilevel) === 3"
									[class.status-error-fg]="(asset.rtbhealth | hilevel) === 4">{{asset.rtbmax
									| number : "1.2-2" | ifempty : "N/A"}}</div>
								<div class="section-rul"></div>
								<button class="btn btn-info btn-block" (click)="selectView('rtb')" [class.selected]="selectedview === 'rtb'">
									<span class="d-none d-md-inline-block">Show</span> Details
								</button>
							</div>
							<div *ngIf="api.user.hide_rtb === 1" class="detail-panel">
								<div class="section-title">Rotor Track + Balance</div>
								<div>Not available</div>
							</div>
						</div>
						<div class="col-6 col-md-4 detail-column">
							<div *ngIf="api.user.hide_fdm !== 1" class="detail-panel">
								<div class="section-title">FDM + Exceedances</div>
								<div class="section-description">Total Unacknowledged Exceedances</div>
								<div class="big-number" [class.status-ok-fg]="asset.exceedancecount === 0" [class.status-warning-fg]="asset.exceedancecount > 0"
									[class.status-error-fg]="asset.severeexceedancecount > 0">
									{{asset.exceedancecount}}</div>
								<div class="section-rul"></div>
								<button class="btn btn-info btn-block" (click)="selectView('exceed')" [class.selected]="selectedview === 'exceed'">
									<span class="d-none d-md-inline-block">Show</span> Details
								</button>
							</div>
							<div *ngIf="api.user.hide_fdm === 1" class="detail-panel">
								<div class="section-title">FDM + Exceedances</div>
								<div>Not available</div>
							</div>
						</div>
						<div class="clearfix d-md-none"></div>
						<div class="col-6 col-md-4 detail-column">
							<div *ngIf="api.user.hide_mech !== 1" class="detail-panel">
								<div class="section-title">{{brand.mechName}}</div>
								<div class="section-description">Highest HI</div>
								<div class="big-number" [class.status-ok-fg]="(asset.mdmax | hilevel) === 1" [class.status-warning-fg]="(asset.mdmax | hilevel) === 3"
									[class.status-error-fg]="(asset.mdmax | hilevel) === 4">{{asset.mdmax | number : "1.2-2"}}</div>
								<div class="section-rul">
									<div *ngIf="asset.rulmin" class="rul-shortest">Shortest RUL:
										<span class="value">{{asset.rulmin | number : "1.2-2"}} hr</span>
									</div>
									<div *ngIf="asset.rulmin && worstrulcomponent" class="rul-component">Component:
										<span class="value">{{worstrulcomponent?.name}}</span>
									</div>
									<div *ngIf="(!asset.rulmin && !worstrulcomponent) && worsthicomponent" class="rul-component">
										Component:
										<span class="value">{{worsthicomponent?.name}}</span>
									</div>
								</div>
								<button class="btn btn-info btn-block" (click)="selectView('mech')" [class.selected]="selectedview === 'mech'">
									<span class="d-none d-md-inline-block">Show</span> Details
								</button>
							</div>
							<div *ngIf="api.user.hide_mech === 1" class="detail-panel">
								<div class="section-title">{{brand.mechName}}</div>
								<div>Not available</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- ALL ASSETS -->
	<app-rtb *ngIf="selectedview === 'rtb' && api.user.hide_rtb !== 1" [asset]="asset" [fleet]="fleet"></app-rtb>
	<app-fdm *ngIf="selectedview === 'exceed' && api.user.hide_fdm !== 1" [asset]="asset" [fleet]="fleet" [components]="components"></app-fdm>
	<app-mech-diag *ngIf="selectedview === 'mech' && api.user.hide_mech !== 1" [asset]="asset" [fleet]="fleet" [components]="components"></app-mech-diag>
</div>
<div *ngIf="asset === undefined" class="text-center pt-3 pb-5">
	<div class="logo-spin light"></div>
	Loading asset...
</div>